<template>
  <div class="page-class page-setting-list">
    <div class="page-class">
      <b-row class="table-bottom-wrapper m-2 mx-0">
        <b-col lg="2" sm="12" class="px-0">
          <b-button
            data-v-step="4"
            @click="certificateForm"
            size="sm"
            :class="{
              'box-shadow2 btn btn-success mr-2': !isDarkMode,
              'btn btn-primary text-light mr-2': isDarkMode
            }"
          >
            <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />Certificate Form
          </b-button>
        </b-col>
        <b-col lg="2" sm="12" class="px-0">
          <b-button
            data-v-step="4"
            @click="uploadCertificate"
            size="sm"
            :class="{
              'box-shadow2 btn btn-success mr-2': !isDarkMode,
              'btn btn-primary text-light mr-2': isDarkMode
            }"
          >
            <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />Upload CC
          </b-button>
        </b-col>
      </b-row>
      <div>
        <div>
          <div
            :class="{
              'my-4 rounded': !isDarkMode,
              'my-4 bg-dark rounded text-light': isDarkMode
            }"
          >
            <div>
              <div
                :class="{
                  'box-shadow2 my-3': !isDarkMode,
                  'my-3': isDarkMode
                }"
              >
                <div
                  :class="{
                    'table-row table-row-header text-center': !isDarkMode,
                    'table-row-dark text-center dark-div border-top': isDarkMode
                  }"
                >
                  <div
                    v-for="column in columns"
                    :key="column.id"
                    :class="{ 'table-column bg-light': !isDarkMode, 'table-column-dark': isDarkMode }"
                    :style="columnStyle(column)"
                  >
                    {{ column.headerText }}
                  </div>
                </div>
                <div
                  :class="{
                    'table-row text-center ': !isDarkMode,
                    'table-row-dark text-center': isDarkMode
                  }"
                  v-for="row in rows"
                  :key="row.id"
                >
                  <div
                    v-for="column in columns"
                    :key="column.id"
                    :class="{ 'table-column': !isDarkMode, 'table-column-dark': isDarkMode }"
                    :style="columnStyle(column)"
                  >
                    <slot v-if="column.slotKey" :name="column.slotKey" v-bind:row="row"></slot>
                    <div v-if="column.htmlKey" v-html="row[column.htmlKey]"></div>
                    <div v-if="column.urlKey">
                      <a :href="row[column.urlKey]" target="_blank">{{ row[column.urlKey] }}</a>
                    </div>
                    <span v-if="column.textKey" class="span-text">
                      {{ row[column.textKey] }}
                    </span>
                    <span
                      v-if="column.textKey === 'actions'"
                      :class="{ 'table-column': !isDarkMode, 'table-column-dark': isDarkMode }"
                    >
                      <b-button :variant="isDarkMode ? 'outline-light' : 'secondary'" size="sm" @click="editRow(row)"
                        >View/Edit</b-button
                      >
                    </span>
                    <span
                      v-if="column.textKey === 'actions'"
                      :class="{ 'table-column': !isDarkMode, 'table-column-dark': isDarkMode }"
                    >
                      <b-button :variant="isDarkMode ? 'outline-danger' : 'danger'" size="sm" @click="deleteRow(row)"
                        >Delete</b-button
                      >
                    </span>
                  </div>
                </div>
                <div
                  v-if="!loading && rows.length === 0"
                  :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }"
                >
                  <div
                    :class="{
                      'table-column table-column-full text-center': !isDarkMode,
                      'table-column-dark table-column-full text-center': isDarkMode
                    }"
                  >
                    {{ emptyText }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-row class="table-bottom-wrapper mt-2 mx-0">
        <b-col lg="3" sm="12"> </b-col>
        <b-col lg="3" sm="12"> </b-col>
        <b-col lg="3" sm="12"> </b-col>
        <b-col lg="3" sm="12" v-if="showPagination">
          <div class="d-flex justify-content-end">
            <b-pagination-nav
              data-v-step="7"
              v-if="rows.length"
              v-model="currentPage"
              :link-gen="linkGen"
              :number-of-pages="totalNumberOfPage ? totalNumberOfPage : 1"
              use-router
              no-page-detect
              align="right"
              :class="{ '': !isDarkMode, 'dark-nav': isDarkMode }"
            ></b-pagination-nav>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Vue from 'vue';
import csv from 'csvtojson';
import router from '@/router';

export default {
  name: 'PettyCashCertificateList',
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  props: {
    rows: [],
    columns: [],
    showPagination: Boolean,
    pagination: Object
  },
  data() {
    return {
      loading: false,
      emptyText: 'No data available'
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('darkMode', ['isDarkMode']),
    metaDescription() {
      return 'Petty cash Certificate List';
    },
    currentPage() {
      if (this.pagination.page) {
        return this.pagination.page;
      }
      return 1;
    },
    totalNumberOfPage() {
      if (this.pagination) {
        if (this.pagination.total_rows && this.pagination.page_size) {
          return Math.ceil(this.pagination.total_rows / this.pagination.page_size);
        }
      }
      return 0;
    },
    totalCount() {
      if (this.pagination) {
        return this.pagination.total_rows;
      }
      return 0;
    }
  },
  methods: {
    ...mapActions('pettyCash', ['postUploadCertificate']),
    certificateForm() {
      router.push('/petty-cash/certificate/cc/form');
    },
    async uploadCertificate() {
      const result = await Vue.swal({
        title: 'Upload file for Certificate..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your Certificate in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      });

      if (result.isDenied) {
        this.createCsv();
        return;
      }

      if (result.value) {
        const file = result.value;
        const reader = new FileReader();
        reader.onload = async () => {
          try {
            const csvString = reader.result;
            const data = await csv().fromString(csvString);
            this.postUploadCertificate({
              certificate: data,
              router,
              redirectUrl: '/petty-cash/certificate/cc/upload'
            });
            // this.rows = data;
          } catch (error) {
            console.error('Error parsing CSV:', error);
          }
        };
        reader.onerror = error => {
          console.error('Error reading file:', error);
        };
        reader.readAsText(file);
      }
    },
    createCsv() {
      const csv = `Company Name,Store Code,Store Name,Main Cash as per the DC1 report,Float Cash as per system,Petty Cash as per system,Quarter\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleCertificate.csv';
      anchor.click();
    },
    columnStyle(column) {
      return { width: column.width };
    },
    editRow(row) {
      this.$emit('edit', { row });
    },
    deleteRow(row) {
      Vue.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        preConfirm: () => {
          this.$emit('delete', { row });
        },
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      });
    }
  }
};
</script>
